import React from 'react'
import useFormV2 from '../../form-v2/form.hook';
import FormV2 from '../../form-v2/form.component';

const AddressModalComponent = (props) => {
    if (!props.uData || !props.patientAddressModal || props.patientAccountModal) return null;
    if (typeof window !== 'undefined' && localStorage?.getItem?.('hidePatientModal') && [true, 'true'].includes(localStorage?.getItem?.('hidePatientModal'))) return null;
    return (
        <div className='patient-address-modal-overlay'>
            <div className='patient-address-modal'>
                <PatientAddressForm {...props} />
            </div>
        </div>
    )
}

export default AddressModalComponent;

const PatientAddressForm = (props) => {

    const form = useFormV2({
        title: 'Address details',
        subtitle: 'Please enter your address details, so that we can provide you with the best service possible.',
        classNames: {
            header: 'address-modal-header',
        },
        autoFetch: {
            url: '/users/account/address',
            skipFetchErrorHandling: true,
        },
        autoSubmit: {
            method: 'post',
            url: '/users/account/update',
            onAfterSubmit: () => {
                props?.verifyUser?.();
            }
        },
        buttons: {
            submit: {
                custom: ({ lang }) => <button
                    type='submit'
                    className='auth-2fa-button'
                >
                    {'Confirm'.translate(lang)}
                </button>
            }
        }
    }, {
        street: {
            type: 'text',
            isRequired: true,
            label: 'Street',
            cols: 12,
            config: {
                autoComplete: 'street-address'
            }
        },
        zip: {
            type: 'text',
            isRequired: true,
            label: 'Postal code',
            cols: { lg: 4, xl: 4, xxl: 4, md: 4, sm: 12 },
            config: {
                autoComplete: 'postal-code'
            }
        },
        city: {
            type: 'text',
            isRequired: true,
            label: 'City',
            cols: { lg: 8, xl: 8, xxl: 8, md: 8, sm: 12 },
            config: {
                autoComplete: 'address-level2'
            }
        },
    }, {
        props
    });
    return <div>
        <FormV2 data={form} lang={props.lang} />

        <div className='address-modal-reset-button'>
            <button
                type='button'
                onClick={() => {
                    props?.hideAddressModal?.();
                }}
            >
                {'Skip until next time'.translate(props.lang)}
            </button>
        </div>
    </div>
}